<template>

	<page>
		<title-view>
			ניהול ערים
			<v-btn slot="actions" btn @click="openModal = true">הוסף עיר</v-btn>
		</title-view>
		<row>
			<c-col>
				<cities-table @edit="onEdit"/>
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">יצירת/עריכת עיר</span>
			<city-form @save="openModal=false"/>
		</popup-dialog>

	</page>


</template>

<script>
	import CityForm from "src/view/cities/CityForm";
	import CitiesTable from "src/view/cities/CitiesTable";
	import CityModule from "src/store/modules/City.module";

	export default {
		name: "cities-view",
		components: {CitiesTable, CityForm},
		data() {
			return {
				openModal: false
			};
		},
		methods: {
			onEdit(City) {
				this.$store.commit(CityModule.types.GET, City);
				this.openModal = true;
			}
		}

	};
</script>

<style scoped>

</style>
